import { Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Translate from "src/components/translate";
import { WORD_PRESS_REFERRAL_LINK } from "src/config";
import useResponsive from "src/hooks/useResponsive";
import LanguagePopover from "src/layouts/shared/header/language-popover";
import { PATH_AUTH } from "src/routes/paths";

const NoAccountSection = () => {
  const smUp = useResponsive("up", "sm");

  return (
    !smUp && (
      <Stack mt={2} direction="row" alignItems="center" spacing={1}>
        <LanguagePopover />
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="body2" align="center" sx={{ mt: 3 }}>
            <Translate>register.don't_have</Translate>&nbsp;
          </Typography>
          <a
            target="_blank"
            style={{ textDecoration: "none", color: "#07325a" }}
            href={WORD_PRESS_REFERRAL_LINK}
          >
            <Translate>register.get_started</Translate>
          </a>
        </Stack>
      </Stack>
    )
  );
};

export default NoAccountSection;
